{
  "login": {
    "title": "Login to your account",
    "description": "Enter your account details to continue.",
    "identifier": "Email or Username",
    "password": "Password",
    "submit": "Login",
    "submitting": "Signing in...",
    "forgot": "Forgot your password?",
    "orContinueWith": "Or continue with",
    "withNfc": "Login with NFC",
    "errors": {
      "invalidCredentials": "The username or password is incorrect",
      "accountLocked": "The account is temporarily locked due to too many attempts. Try again in 15 minutes.",
      "accountLockedUntil": "The account is temporarily locked due to too many attempts. Try again after {{time}}.",
      "accountInactive": "Account is inactive, contact your administrator",
      "accountPending": "This account has not completed setup yet. Contact your administrator for a new setup link.",
      "network": "Could not reach the server. Check your connection and try again."
    }
  },
  "nfc": {
    "title": "NFC Card Login",
    "description": "Please scan your NFC card on the reader",
    "waiting": "Waiting for NFC card...",
    "detected": "Card detected! Authenticating...",
    "cancel": "Cancel"
  },
  "forgotPassword": {
    "title": "Forgot your password",
    "description": "Enter your username or email and we will send a reset link if your email is on file.",
    "submit": "Send",
    "sent": "If an email is on file for this account, a reset link has been sent. If you don't receive anything, contact your administrator.",
    "backToLogin": "Back to Login"
  },
  "setPassword": {
    "setupTitle": "Complete Registration",
    "resetTitle": "Set Password",
    "loading": "Loading...",
    "new": "New Password",
    "confirm": "Confirm Password",
    "current": "Current Password",
    "submit": "Save",
    "success": "Password saved successfully",
    "mismatch": "Passwords do not match",
    "required": "This field is required",
    "tooShort": "The password must be at least 8 characters",
    "equalsUsername": "The password cannot be the same as the username",
    "strength": {
      "weak": "Weak",
      "fair": "Fair",
      "good": "Good",
      "strong": "Strong"
    }
  },
  "selectBranch": {
    "title": "Select Branch",
    "description": "Choose the branch you work in.",
    "branch": "Branch",
    "placeholder": "Select a branch...",
    "confirm": "Confirm Selection",
    "noBranch": "No access to any branch, contact your administrator"
  },
  "action": {
    "backToLogin": "Back to Login"
  }
}
